import React from "react";
import Project1 from '../asset/Screenshot 2024-10-21 092418.png';
import Project2 from '../asset/weather.png';
import Project3 from '../asset/webmusic.png';


const Project = () => {

        return(
            <section id="project" className="py-14 bg-color1">
            <div className="container mx-auto text-center">
            <hr className="mb-20 h-1 bg-white rounded-full"/>

                <h1 className="text-4xl font-bold mb-8 text-black">Project</h1>
            
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" >
                    <div className="bg-white p-6 rounded-lg relative">
                    <img src={`${Project1}`} alt="samuel wattimena" className="w-full h-48 object-cover mb-4 rounded-md placeholder-opacity-80 "/>
                        <p className="text-lg text-black">Membuat sebuah program gif generator</p>
                    </div>

                    <div className="bg-white p-6 rounded-lg hover:bg-white transition-colors duration-300">
                    <img src={`${Project2}`} alt="samuel wattimena" className="w-full h-48 object-cover mb-4 rounded-md placeholder-opacity-80 "/>
                        <p className="text-lg text-black">Membuat web cuaca menggunakan nodejs</p>
                    </div>
                    <div className="bg-white p-6 rounded-lg hover:bg-white transition-colors duration-300">
                    <img src={`${Project3}`} alt="samuel wattimena" className="w-full h-48 object-cover mb-4 rounded-md placeholder-opacity-80 "/>
                        <p className="text-lg text-black">Membuat Project desain web music menggunakan Figma</p>
                    </div>
                </div>
            </div>

         
        </section>
        )
}

export default Project;